import React, {useState} from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from 'react-redux';
import { Dispatch } from "redux";
import { AuthApis } from "../../apis/authApis";
import { login } from "../../reducer/loginSlice";
import { NavLink, useNavigate,Link } from "react-router-dom";

export default function Navbar({ title }) {
  const [toggle, setToggle] = useState(false)

  const dispatch = useDispatch();
  const userLoginData = useSelector((state) => state.data.login.value);

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const navigate = useNavigate();
  // && userLoginData.data?.user_data?.isVerified == 'true'

  React.useEffect(() => {
    if(!userLoginData?.token){
      dispatch(login([]))
      navigate('/sign-in');
    }
     
  }, []);

  // React.useEffect(() => {
  //   if(userLoginData.data?.user_data?.status == 'pending'){
  //     navigate("/kyc")
  //   }else if(userLoginData.data?.user_data?.status == 'inReview'){
  //     navigate("/kyc")
  //   }
  // }, []);

  const logOut = () => {
    AuthApis.logout('').then(
      (response) => {
        if (response?.data) {
          dispatch(login([]))
          navigate('/sign-in');

        }
      }
    ).catch(function (error) {
      dispatch(login([]))
      navigate('/sign-in');
    }).finally(function(){
      dispatch(login([]))
      navigate('/sign-in');
    }
      
    )

  };


  
  return (
    <>
      <div className="relative bg-lightBlue-600 mb-8">
        {/* Navbar */}
        <header className="flex justify-between items-center ">

          <div></div>
            <div className="flex-1 max-w-md">
              <div className="relative">
                <input
                  type="search"
                  placeholder="Search"
                  className="w-full pl-4 pr-10 py-2 border rounded-lg"
                />
                <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-blue-600 text-white px-4 py-1 rounded-lg">
                  Search
                </button>
              </div>
            </div>
            <div className="ml-4 items-center  hidden md:flex">
              <img
                src={userLoginData?.data?.userProfile?.image_url}
                alt={userLoginData?.data?.userProfile?.image_url}
                className="w-8 h-8 rounded-full"
              />
              <span className="ml-2">{userLoginData?.data?.user_data?.first_name}</span>
              {userLoginData?.data?.user_plan?.is_lifetime && (
                <span className="ml-2 bg-amber-100 text-amber-800 text-xs font-semibold px-2.5 py-1 rounded-full">
                  Lifetime
                </span>
              )}
            </div>
          
          </header>
          <hr className="mt-2"/>
      </div>
      {/* End Navbar */}
    </>
  );
}

Navbar.defaultProps = {
  title: " ",
};
